// extracted by mini-css-extract-plugin
export default {"table":"d8ZaMKDNwRcuNM_5snX8","entitiesCounter":"ZwQDXpraF9Dq8EkGrGVS"};